export const MIN_PASSWORD_LENGTH = 8;

function randomIndex(max) {
  const limit = Math.floor(0x100000000 / max) * max;
  const buf = new Uint32Array(1);
  do {
    window.crypto.getRandomValues(buf);
  } while (buf[0] >= limit);
  return buf[0] % max;
}

function pickChar(chars) {
  return chars.charAt(randomIndex(chars.length));
}

export function generatePassword(length = MIN_PASSWORD_LENGTH) {
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const allChars = lower + upper + numbers;

  const password = [pickChar(lower), pickChar(upper), pickChar(numbers)];

  while (password.length < length) {
    password.push(pickChar(allChars));
  }

  // Fisher-Yates: sort() со случайным компаратором перемешивает неравномерно
  for (let i = password.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join("");
}

export function isValidPassword(password) {
  const hasNumber = /\d/;
  const hasUppercase = /\p{Lu}/u;

  return (
    password.length >= MIN_PASSWORD_LENGTH &&
    hasNumber.test(password) &&
    hasUppercase.test(password)
  );
}
